import decode from 'jwt-decode'

const stripXprops = (props) => {
    const newProps = {
        ...props,
        scope: props.scope || 'guest',
    }

    // debugger
    try {
        const token = decode(props.accessToken)
        newProps.scope = token?.scope || newProps.scope
    } catch (error) {
        // we do not need to know if the accessToken was decoded
        // so we don't need to log an error here
    }

    delete newProps.cspNonce
    delete newProps.close
    delete newProps.focus
    delete newProps.getParent
    delete newProps.getParentDomain
    delete newProps.hide
    delete newProps.onClose
    delete newProps.onDestroy
    delete newProps.onDisplay
    delete newProps.onError
    delete newProps.onFocus
    delete newProps.onProps
    delete newProps.onRender
    delete newProps.onRendered
    delete newProps.onResize
    delete newProps.resize
    delete newProps.show
    delete newProps.timeout
    delete newProps.window

    return newProps
}

export default stripXprops
